export default "__VITE_PUBLIC_ASSET__8577b4fa__"